import React from 'react'
import NavbarM from './NavBarM'
import { withRouter } from 'react-router-dom';
import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import InputGroup from 'react-bootstrap/InputGroup'
import Button from 'react-bootstrap/Button'
import { MDBIcon, MDBBtn } from 'mdbreact';
import axiosInstance from '../axiosInstance'
import Modal from 'react-bootstrap/Modal'
class UpdateTable extends React.Component{
    constructor(){
        super()
        this.state= {
            billing_number:'',
            first_name:'',
            last_name:'',
            personal_number:'',
            address:'',
            definition:'other',
            phone:'',
            comment:'',
            city:'',
            errors:{
                billing_number:false,
                first_name:false,
                last_name:false,
                definition:false,
                city:false,
                personal_number:false,
            },
            modal:false,
            error_messages:{
                billing_error_message:'გთხოვთ შეიყვანოთ საბილინგო ნომერი',
                first_name_error_message:'გთხოვთ შეიყვანოთ სახელი',
                last_name_error_message:'გთხოვთ შეიყვანოთ გვარი',
                phone_error_message:'გთხოვთ შეიყვანოთ მობილური',
                address_error_message:'გთხოვთ შეიყვანოთ მისამართი',
                city_error_message:'გთხოვთ შეიყვანოთ ქალაქი',
                personal_number_error_message:'გთხოვთ შეიყვანოთ პირადი ნომერი'
            }
        }
    }
    onChange(event){
        this.setState(
            {[event.target.name]:event.target.value,
                errors:{
                    ...this.state.errors,
                    [event.target.name]:false 
                }
            }
        )
    }


    valid(){
        var billing = (this.state.billing_number === '')
        var firstname = (this.state.first_name === '');
        var secondname =(this.state.last_name === '');
        var address = (this.state.address === '');
        var phone = (this.state.address === '');
        var city = (this.state.city === '')
        var personal_number = (this.state.personal_number === '')
        if(billing || firstname || secondname || address || phone||personal_number){
            this.setState({
                errors:{
                    billing_number:billing,
                    first_name:firstname,
                    last_name:secondname,
                    address:address,
                    phone:phone,
                    city:city,
                    personal_number:personal_number
                },
                error_messages:{
                    ...this.state.error_messages,
                    billing_error_message:'გთხოვთ შეიყვანოთ საბილინგო ნომერი'
                }
            })
            return false;
        }
        return true;
    }
    afterInsert(data){
        this.setState({
            ...this.state,
            modal:true
        })
    }

    sendData(){
        var data = new FormData();
        data.append('action','insert');
        data.append('billing_number',this.state.billing_number);
        data.append('first_name', this.state.first_name);
        data.append('last_name', this.state.last_name);
        data.append('definition', this.state.definition);
        data.append('phone', this.state.phone);
        data.append('comment', this.state.comment);
        data.append('address',this.state.address);
        data.append('city',this.state.city)
        data.append('personal_number',this.state.personal_number);
        
        if(this.valid()){
            axiosInstance.post("api.php",data)
            .then(data =>this.afterInsert(data))
            .catch(err =>{
                if(err.response.status === 401){
                    this.props.history.push('/login')
                }
            })
        }
    }

    afterBillingFetch(data){
        this.setState({
            ...this.state,
            first_name:data.data.first_name,
            last_name:data.data.last_name,
            address:data.data.address,
            phone:data.data.phone,
            city:data.data.city,
            personal_number:data.data.personal_number
        })
    }


    logout(){
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        this.props.history.push('/login')
    }

    fetchBillingInfo(){
        if(this.state.billing_number === ''){
            this.setState({
                errors:{
                    ...this.state.errors,
                    billing_number:true
                }
            })
            return;
        }
        axiosInstance.get("api.php", {params: {
            action: "billing_info",
            billing_number: this.state.billing_number
        }})
        .then(data =>this.afterBillingFetch(data))
        .catch(err =>  {
            if(err.response.status === 401){
                this.logout();
            }
            if(err.response.status === 400){
                this.setState({
                    ...this.state,
                    errors:{
                        ...this.state.errors,
                        billing_number:true
                    },
                    error_messages:{
                        ...this.state.error_messages,
                        billing_error_message:'მონაცემები ვერ მოიძებნა'
                    }
                })
            }
        }
           
        )
    }

    modalClose(){
        this.setState({
            billing_number:'',
            first_name:'',
            last_name:'',
            address:'',
            definition:'',
            phone:'',
            comment:'',
            city:'',
            errors:{
                billing_number:false,
                first_name:false,
                last_name:false,
                definition:false,
                address:false,
                city:false
            },
            modal:false
        })
    }
    render(){
        return (
            <div>
                <NavbarM user = {1}/>
                <div className="container container-update row-content">
                    <Form.Row >
                        <Form.Group as={Col} md="4" controlId="validationFormik03">
                            <Form.Label>საბილინგო ნომერი</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="number"
                                    name="billing_number"
                                    onChange = {(event)=>this.onChange(event)}
                                    isInvalid = {Boolean(this.state.errors.billing_number)}
                                    value = {this.state.billing_number}
                                />
                                 <InputGroup.Prepend>
                                    <MDBBtn  color="success" onClick={(event)=>this.fetchBillingInfo(event)} >
                                        <MDBIcon icon="check" />
                                    </MDBBtn>
                                    {/* 
                                    <Button variant="success"></Button> */}
                                </InputGroup.Prepend>
                                <Form.Control.Feedback type="invalid" >
                                    {this.state.error_messages.billing_error_message}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group as={Col} md="3" controlId="validationFormik01">
                            <Form.Label>სახელი</Form.Label>
                            <Form.Control
                                type="text"
                                name="first_name"
                                onChange = {(event)=>this.onChange(event)}
                                isInvalid = {Boolean(this.state.errors.first_name)}
                                value = {this.state.first_name}
                            />
                            <Form.Control.Feedback type="invalid" >
                            {this.state.error_messages.first_name_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col}  md="3" controlId="validationFormik02">
                            <Form.Label>გვარი</Form.Label>
                            <Form.Control
                                type="text"
                                name="last_name"
                                onChange = {(event)=>this.onChange(event)}
                                isInvalid = {Boolean(this.state.errors.last_name)}
                                value = {this.state.last_name}
                            />
                            <Form.Control.Feedback type="invalid" >
                            {this.state.error_messages.last_name_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col}  md="2" controlId="validationFormik02">
                            <Form.Label>პირადი ნომერი</Form.Label>
                            <Form.Control
                                type="number"
                                name="personal_number"
                                onChange = {(event)=>this.onChange(event)}
                                isInvalid = {Boolean(this.state.errors.personal_number)}
                                value = {this.state.personal_number}
                            />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.error_messages.personal_number_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="3" controlId="validationFormik010">
                            <Form.Label>ქალაქი</Form.Label>
                            <Form.Control
                                type="text"
                                name="city"
                                onChange = {(event)=>this.onChange(event)}
                                isInvalid = {Boolean(this.state.errors.city)}
                                value = {this.state.city}
                            />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.error_messages.city_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="validationFormik04">
                            <Form.Label>მისამართი</Form.Label>
                            <Form.Control
                                type="text"
                                name="address"
                                onChange = {(event)=>this.onChange(event)}
                                isInvalid = {Boolean(this.state.errors.address)}
                                value = {this.state.address}
                            />
                             <Form.Control.Feedback type="invalid" >
                             {this.state.error_messages.address_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="3" controlId="validationFormik03">
                            <Form.Label>მობილური</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="number"
                                    name="phone"
                                    onChange = {(event)=>this.onChange(event)}
                                    isInvalid = {Boolean(this.state.errors.phone)}
                                    value = {this.state.phone}
                                />
                                <Form.Control.Feedback type="invalid" >
                                {this.state.error_messages.phone_error_message}
                                </Form.Control.Feedback>
                            </InputGroup>
                            
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col}  md="8" controlId="validationFormik05">
                            <Form.Label>კომენტარი</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="comment"
                                    onChange = {(event)=>this.onChange(event)}
                                    value = {this.state.comment}
                                />     
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="validationCustomUsername">
                            <Form.Label>აღწერა</Form.Label>
                            <InputGroup>
                                <Form.Control as="select" name = "definition"
                                onChange = {(event)=>this.onChange(event)}
                                >
                                    <option value="other" defaultValue>სხვა</option>
                                    <option value="new_stb">ახალი STB</option>
                                    <option value="replace_stb">შესაცვლელია STB</option>
                                    <option value="remove_stb">წამოსაღებია STB</option>
                                    <option value="replace_remote_new">ახალი პულტი</option>
                                    <option value="replace_remote_secondary">მეორადი პულტი</option>
                                    <option value="replace_charger">კვების ბლოკის შეცვლა</option>
                                    <option value="replace_hdmi_wire">HDMI კაბელის შეცვლა</option>
                                    <option value="replace_rci_wire">RCI კაბელის შეცვლა</option>
                                    <option value="replace_ethernet_wire">Ethernet კაბელის შემოწმება/შეცვლა</option>
                                    <option value="presentation">პრეზენტაცია</option>
                                </Form.Control>
                            </InputGroup>
                        </Form.Group>
                    </Form.Row>
                    <Button variant="secondary" size="md" onClick={(event)=>this.sendData(event)}>დამატება</Button>
                    <Modal show= {this.state.modal} centered>
                        <Modal.Body>
                            მონაცემი წარმატებით ჩაემატა!
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="success" onClick ={(event)=>this.modalClose(event)} >
                                ok
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
            
        );
    }
}
export default withRouter(UpdateTable) ;